<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>製品的安全性</h1>
        </div>
      </header>
      <HeaderNav activeLink="manufacturing" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">富地滋製品的安全性概要</h2>
            <p>
              關於「富地滋DN膠原」等主要食品皆會定期進行毒性試驗、放射能檢查以確認其安全性。
              <br />
              保養品系列產品則是進行貼膚測試與過敏測試。
            </p>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">富地滋DN膠原</h2>
            <table class="manufactoring-table">
              <tr>
                <th class="td-bg-dark" colspan="2">試驗項目：毒性試驗</th>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  單次口服毒性試驗(大白鼠)
                </th>
              </tr>
              <tr>
                <th>試驗 ‧ 檢查機關</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則 ‧ 試驗法概要</th>
                <td>
                  醫藥品毒性試驗法準則 <br />
                  〔1〕單次口服毒性測試(平成元年9月11日
                  藥審1第24號、平成5年8月10日藥新藥第88號)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>
                  LD50&gt;20ml/kg <br />
                  無死亡例、一般狀態的異常、體重異常的情況發生，根據病理解剖並判斷無異常，因此無顯示急性毒性。
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  28天反覆口服毒性試驗(大白鼠)
                </th>
              </tr>
              <tr>
                <th>試驗 ‧ 檢查機關</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則 ‧ 試驗法概要</th>
                <td>
                  「「關於食品添加物的指定及使用基準改正方針」(平成8年3月22日
                  衛化第29號)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>
                  NOAEL&gt;10ml/kg/日
                  <br />
                  無死亡例、一般狀態的異常、體重異常的情況發生，根據血液學檢查、病理組織學的檢查等並判斷無異常，因此無毒性。
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  回復突變試驗(Ames test /安姆氏測試法)
                </th>
              </tr>
              <tr>
                <th>試驗 ‧ 檢查機關</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則 ‧ 試驗法概要</th>
                <td>
                  「關於醫藥品的遺傳毒性測試及相關解釋之指導」(平成24年9月20日
                  藥食審查發0920第2號)「OECD化學物質測試法指導準則471、使用細菌的回復突變試驗」(OECDTG471、1997年7月21日)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>陰性(沒有基因突變誘因)</td>
              </tr>
            </table>
            <p>『被試驗物：2018年5月製造品(第八世代)』</p>
            <p>
              敝公司平時致力於確立品質管理體制及確保製品的安全性。東日本大震災發生後，為了提供客人更多的安全及安心，我們會於原材料供給的地方進行放射性物質的確認並將其結果報告給各位。
            </p>
          </div>
        </section>
        <!-- <section class="m-sec">
          <div class="container">
            <h2 class="section-title">新‧夢莎ED膠原蛋白飲</h2>
            <table class="manufactoring-table">
              <tr>
                <th class="td-bg-dark" colspan="2">測試項目：毒性測試</th>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  單次口服毒性測試(白老鼠)
                </th>
              </tr>
              <tr>
                <th>測試、檢查機構</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則、試驗法概要</th>
                <td>
                  醫藥品毒性測試法準則
                  <br />[1]單次口服毒性測試(平成元年9月11日藥審1第24號、平成5年8月10日藥新藥第88號)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>
                  LD50 &gt; 20mL/kg
                  <br />無死亡例、一般狀態的異常、體重異常的情況發生，根據病理解剖並判斷無異常，因此無顯示急性毒性。
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  28 天反覆進行口服毒性測試(白老鼠)
                </th>
              </tr>
              <tr>
                <th>測試、檢查機構</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則、試驗法概要</th>
                <td>
                  「關於食品添加物的指定及使用基準改政方針」(平成8年3月22日衛化第29號)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>
                  NOAEL &gt; 10mL/kg
                  <br />無死亡例、一般狀態的異常、體重異常的情況發生，根據血液學檢查、病理組織學的檢查等並判斷無異常，因此無毒性。
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  恢復後突然變異測試(安姆氏試驗)
                </th>
              </tr>
              <tr>
                <th>測試、檢查機構</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則、試驗法概要</th>
                <td>
                  「關於醫藥品的遺傳毒性測試及相關解釋之指導」(平成24年9月20日、藥食審查發0920第2號)「OECD化學物質測試法指導準則471、使用細菌的恢復後突然變異的試驗」(OECDTG471、1997年7月21日)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>陰性(無顯示出引發基因突變的可能)</td>
              </tr>
            </table>
            <p>『被試驗物：2019年1月製造品』</p>
          </div>
        </section> -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">富地滋樂活隨身包</h2>
            <table class="manufactoring-table">
              <tr>
                <th class="td-bg-dark" colspan="2">試驗項目：毒性試驗</th>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  單次口服毒性試驗(大白鼠)
                </th>
              </tr>
              <tr>
                <th>試驗 ‧ 檢查機關</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則 ‧ 試驗法概要</th>
                <td>
                  醫藥品毒性試驗法準則 <br />
                  〔1〕單次口服毒性測試 <br />
                  (平成元年9月11日 藥審1第24號、平成5年8月10日、藥新藥第88號)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>
                  LD50&gt;2000mg/kg
                  <br />
                  無死亡例、一般狀態的異常、體重異常的情況發生，根據病理解剖並判斷無異常，因此無顯示急性毒性。
                </td>
              </tr>
              <tr>
                <th class="td-bg-middle-dark" colspan="2">
                  28 天反覆進行口服毒性測試(白老鼠)
                </th>
              </tr>
              <tr>
                <th>測試、檢查機構</th>
                <td>(一般財團法人)食品藥品安全中心</td>
              </tr>
              <tr>
                <th>指導準則、試驗法概要</th>
                <td>
                  「關於食品添加物的指定及使用基準改政方針」(平成8年3月22日衛化第29號)
                </td>
              </tr>
              <tr>
                <th>結果概要</th>
                <td>
                  NOAEL &gt; 1000mg/kg/日
                  <br />無死亡，判斷無毒性。
                </td>
              </tr>
            </table>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
export default {
  name: "ManufacturingScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  .public-page
    .manufactoring-table
    th:not(.td-bg-middle-dark):not(.td-bg-dark) {
    width: 120px;
  }
}
</style>
